import type { Engine } from "./Engine";

class MouseData {
  x: number = 0;
  y: number = 0;
  deltaX: number = 0;
  deltaY: number = 0;
  movementX: number = 0;
  movementY: number = 0;
  leftClick: boolean = false;
  rightClick: boolean = false;
  onClick: boolean[] = [false, false, false];
  clickNow: boolean[] = [false, false, false];
  scroll: number = 0;
  frameScroll: number = 0;
  moving: boolean = false;
}
class KeyState {
  now: boolean = false;
  last: boolean = false;
  eventBuffer: boolean = false;
  lastRegisteredEvent: KeyboardEvent;
  constructor(lastRegisteredEvent: KeyboardEvent, now: boolean = false, last: boolean = false, eventBuffer: boolean = false) {
    this.lastRegisteredEvent = lastRegisteredEvent
    this.now = now
    this.last = last
    this.eventBuffer = eventBuffer
  }
}
export class Input {
  engine: Engine
  get canvas() {
    return this.engine.canvas!;
  }
  keys: Record<string, KeyState>;
  mouse: MouseData;
  frameKeydown: KeyboardEvent[] = [];
  private _frameKeydownBuffer: KeyboardEvent[] = [];
  private _writingMouse: MouseData;
  private _lastMouse: MouseData;
  constructor(engine: Engine) {
    this.engine = engine;
    this.keys = {};
    this.mouse = new MouseData();
    this._lastMouse = new MouseData();
    this._writingMouse = new MouseData();

    window.addEventListener(
      "keydown",
      (e: KeyboardEvent) => {
        let lastKey = this.keys[String(e.code)]
        if (lastKey === undefined) lastKey = new KeyState(e, false, false, true)
        else lastKey.eventBuffer = true
        this.keys[e.code] = lastKey
        this._frameKeydownBuffer.push(e)
      }
    );
    window.addEventListener(
      "keyup",
      (e: KeyboardEvent) => {
        let lastKey = this.keys[String(e.code)]
        if (lastKey === undefined) lastKey = new KeyState(e, false, false, false)
        else lastKey.eventBuffer = false
        this.keys[e.code] = lastKey
      }
    );

    window.addEventListener("mousemove", (e: MouseEvent) => {
      this._writingMouse.x = e.clientX;
      this._writingMouse.y = e.clientY;
      this._writingMouse.movementX = e.movementX;
      this._writingMouse.movementY = e.movementY;
      this._writingMouse.moving = true;
    });

    this.canvas.addEventListener("mousedown", (e: MouseEvent) => {
      if (e.button == 0) this._writingMouse.leftClick = true;
      if (e.button == 2) this._writingMouse.rightClick = true;
      if (e.button == 0) this._writingMouse.onClick[0] = true;
      if (e.button == 1) this._writingMouse.onClick[1] = true;
      if (e.button == 2) this._writingMouse.onClick[2] = true;
    });
    this.canvas.addEventListener("mouseup", (e: MouseEvent) => {
      if (e.button == 0) this._writingMouse.leftClick = false;
      if (e.button == 2) this._writingMouse.rightClick = false;
      if (e.button == 0) this._writingMouse.onClick[0] = false;
      if (e.button == 1) this._writingMouse.onClick[1] = false;
      if (e.button == 2) this._writingMouse.onClick[2] = false;
    });
    this.canvas.addEventListener("wheel", (e: WheelEvent) => {
      this._writingMouse.scroll += e.deltaY
    })
  }
  update() {

    this.frameKeydown = this._frameKeydownBuffer
    this._frameKeydownBuffer = []
    for (const key in this.keys) {
      this.keys[key].last = this.keys[key].now
      this.keys[key].now = this.keys[key].eventBuffer
    }

    if (!this._writingMouse.moving) { this._writingMouse.movementX = 0; this._writingMouse.movementY = 0; }
    this.mouse = { ...this._writingMouse }

    this.mouse.deltaX = this.mouse.x - this._lastMouse.x;
    this.mouse.deltaY = this.mouse.y - this._lastMouse.y;

    for (let i = 0; i < 3; i++) {
      this.mouse.clickNow[i] = this.mouse.onClick[i] && !this._lastMouse.onClick[i];
    }
    this.mouse.frameScroll = this.mouse.scroll - this._lastMouse.scroll;


    this._writingMouse.moving = false;




    this._lastMouse = { ...this.mouse };
  }

  isPressed(code: string | number) {
    return !!this.keys[String(code)]?.now;
  }
  onPress(code: string | number) {
    if (!this.keys[String(code)]) return false
    return this.keys[String(code)].now && !this.keys[String(code)].last
  }
  getAxis(code1: string | string[], code2: string | string[]) {
    if (!Array.isArray(code1))
      code1 = [code1];
    if (!Array.isArray(code2))
      code2 = [code2];
    let axis = 0;
    let code1Pressed = false;
    let code2Pressed = false;
    for (const code of code1) {
      if (this.isPressed(code)) {
        code1Pressed = true;
        break;
      }
    }
    for (const code of code2) {
      if (this.isPressed(code)) {
        code2Pressed = true;
        break;
      }
    }
    if (code1Pressed) axis += 1;
    if (code2Pressed) axis -= 1;
    return axis;
  }
}
